//Styles
import "./styles.scss";

function DiagonalDivider() {
  return <div className="diagonal-divider" />;
}

export default DiagonalDivider;
